import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress postMessage errors from browser extensions and third-party scripts
const originalConsoleError = console.error;
console.error = (...args) => {
  const errorString = args.map(arg => {
    if (arg instanceof Error) return arg.message;
    if (typeof arg === 'string') return arg;
    try { return JSON.stringify(arg); } catch { return ''; }
  }).join(' ');
  
  if (errorString.includes('postMessage') || errorString.includes('could not be cloned')) {
    return; // Suppress this error
  }
  originalConsoleError.apply(console, args);
};

// Also suppress unhandled errors related to postMessage
window.addEventListener('error', (event) => {
  if (event.message?.includes('postMessage') || event.message?.includes('could not be cloned')) {
    event.preventDefault();
    return false;
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
